/**
 * TanStack Query hooks for `igaming-crypto-payment-tracking-usdt-btc-eth-on-pl`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingCryptoPaymentTrackingUsdtBtcEthOnPlQueryKeys,
	type CreateIgamingCryptoPaymentTrackingUsdtBtcEthOnPlBody,
	type ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlResponse,
	type IgamingCryptoPaymentTrackingUsdtBtcEthOnPlRow,
} from "./api";

export function useIgamingCryptoPaymentTrackingUsdtBtcEthOnPlList(): UseQueryResult<ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlResponse, Error> {
	return useQuery({
		queryKey: igamingCryptoPaymentTrackingUsdtBtcEthOnPlQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingCryptoPaymentTrackingUsdtBtcEthOnPlCreate(): UseMutationResult<IgamingCryptoPaymentTrackingUsdtBtcEthOnPlRow, Error, CreateIgamingCryptoPaymentTrackingUsdtBtcEthOnPlBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingCryptoPaymentTrackingUsdtBtcEthOnPlQueryKeys.all });
		},
	});
}

export function useIgamingCryptoPaymentTrackingUsdtBtcEthOnPlDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingCryptoPaymentTrackingUsdtBtcEthOnPlQueryKeys.all });
		},
	});
}
